import '../../style/base.css';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/lazyload/style/index.js
// module id = qVvv
// module chunks = 0